import React from 'react'
import { connect } from 'react-redux'
import { editSets } from "../../actions/settings"
import Select from 'react-select'
import { sortOpts } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import SettingsItemForm from './SettingsItemForm'

class SetsSrvgItem extends SettingsItemForm {

  modelName = 'srvg'

  render() {
    const { srvms, data } = this.props;
    const { data: nData, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deleteItem}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var srvmsOpt = [];
    for (var key in srvms){
      if(srvms.hasOwnProperty(key) && (srvms[key].srvm_active === 1
        || srvms[key].srvm_id === nData.srvg_srvm_id)) {
        srvmsOpt.push({value:srvms[key].srvm_id,label:srvms[key].srvm_desc});
      }
    }
    srvmsOpt.sort(sortOpts);

    const subtotalOpt = [
      {value: 0, label: 'Нет'},
      {value: 1, label: 'Надбавка'},
      {value: 2, label: 'Налог'}
    ];

    if(this.state.editing){
      return(
        <tr>
          <td>
          {delConf}
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.srvg_desc}
                name="srvg_desc"
                onChange={this.updateInput}
                placeholder="Название"
                autoFocus
              />
            </div>
            <div className="form-inline">
              <button  type="button" className="btn btn-success"
                onClick={this.saveItem} title="Сохранить">
                <span className="glyphicon glyphicon-save"></span>
              </button>{" "}
              <button type="button" className="btn btn-default"
                onClick={this.cancelEditing} title="Отменить">
                <span className="glyphicon glyphicon-remove"></span>
              </button>{" "}
              <button type="button" className="btn btn-danger"
                onClick={this.toggleDelConf} title="Удалить">
                <span className="glyphicon glyphicon-trash"></span>
              </button>
            </div>
            {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          </td>
          <td>
            <Select
              clearable={false}
              options={srvmsOpt}
              value={nData.srvg_srvm_id}
              onChange={e => this.updateSelect(e,'srvg_srvm_id')}
              placeholder="Главная группа услуг"
            />
          </td>
          <td>
            <div className="form-group">
              <input type="text"
                className="form-control"
                value={nData.srvg_sort}
                name="srvg_sort"
                onChange={this.updateInput}
                placeholder="Сортировка"
              />
            </div>
          </td>
          <td>
            <Select
              clearable={false}
              options={subtotalOpt}
              value={nData.srvg_subtotal}
              onChange={e => this.updateSelect(e,'srvg_subtotal')}
              placeholder="После подитога"
            />
          </td>
          <td>
            <input
              type="checkbox"
              checked={nData.srvg_prs}
              name="srvg_prs"
              onChange={this.handleChBox}
            />
          </td>
        </tr>
      );
    }
    else{
      return (
        <tr onClick={this.startEditing}>
          <td>{data.srvg_desc}</td>
          <td>{srvms[data.srvg_srvm_id].srvm_desc}</td>
          <td>{data.srvg_sort}</td>
          <td>{data.srvg_subtotal === 1 ? 'Надбавка' : (data.srvg_subtotal === 2 ? 'Налог' : '')}</td>
          <td>{data.srvg_prs ? '\u2713' : ''}</td>
        </tr>
      );
    }

  }
}

export default connect(null, { editSets })(SetsSrvgItem);



// WEBPACK FOOTER //
// ./src/components/settings/SetsSrvgItem.js